import type { SchemaField, SchemaTab } from '@cli-types/core-engine/schema.js'
import { CREATE_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { deriveAvailableFieldName } from '../schema-prompts/derive-available-field-name.js'
import { promptConfirm } from '../schema-prompts/prompt-confirm.js'
import { promptText } from '../schema-prompts/prompt-text.js'
import { promptSchemaTab } from './prompt-schema-tab.js'

export async function promptSchemaTabsField(
  kind: 'entity' | 'single',
  schemasDir: string,
  titleField: SchemaField
): Promise<SchemaField> {
  const label = await promptText(CREATE_PROMPT_CONTEXT, 'Tabs field label', 'Content')
  const name = deriveAvailableFieldName(label, [titleField.name])
  const tabs: SchemaTab[] = []
  tabs.push(await promptSchemaTab(kind, schemasDir, titleField, tabs))

  while (await promptConfirm(CREATE_PROMPT_CONTEXT, 'Add another tab?', false)) {
    tabs.push(await promptSchemaTab(kind, schemasDir, undefined, tabs))
  }

  return {
    name,
    type: 'tabs',
    label,
    tabs
  }
}
